<template>
  <div class="acupuncture-container">
    <!-- <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-card shadow="hover" v-if="currentPoint" class="point-card">
            <div slot="header">
              <span class="point-name">{{ currentPoint.name }}</span>
            </div>
            <div class="point-detail">
              <p><strong>定位：</strong>{{ currentPoint.location }}</p>
              <p><strong>主治：</strong>{{ currentPoint.functions.join('、') }}</p>
              <p><strong>针刺深度：</strong>{{ currentPoint.depth }}</p>
              <p><strong>注意事项：</strong>{{ currentPoint.caution }}</p>
              <el-image 
                v-if="currentPoint.image" 
                :src="currentPoint.image" 
                fit="contain"
                style="max-height: 150px; margin-top: 10px"
              ></el-image>
            </div>
          </el-card>
          <el-empty v-else description="悬停穴位查看详情"></el-empty>
        </el-col>
      </el-row>
    </el-card> -->
    <div class="parsed-text" v-html="processedText"></div>
    <el-dialog
      title="详情"
      :visible.sync="centerDialogVisible"
      width="80%"
      center
      append-to-body
      modal-append-to-body
      custom-class="acupoint-detail-dialog"
    >
      <div class="WordSegmentPup">
        <div class="WordSegmentPupLeft">
          <div class="info-row">
            <span class="info-label">穴位名称</span>
            <span class="info-value">{{ info.nameAcup }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">拼音</span>
            <span class="info-value">{{ info.pinyin }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">所属经络</span>
            <span class="info-value">{{ info.channels }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">准确定位</span>
            <span class="info-value">{{ info.positionSta }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">其他定位</span>
            <span class="info-value">{{ info.position2 }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">取穴方法</span>
            <span class="info-value">{{ info.acupGet }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">穴位照片</span>
            <span class="info-value">
              <el-image
                :src="info.imgPos1"
                fit="contain"
                :preview-src-list="[info.imgPos1]"
                style="max-width: 250px; cursor: pointer"
              >
              </el-image>
            </span>
          </div>
        </div>
        <div class="WordSegmentPupRight">
          <iframe
            class="iframeBox"
            :src="
              'https://www.baicaojiankang.com/acu?id=' + info.acupuncturePointsId
            "
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 模块级缓存，所有WordSegment实例共享，避免重复调用API
var acupointListCache = null;
var acupointListPromise = null;

export default {
  props: {
    inputText: {
      type: String,
      default: "",
    },
    // list: {
    //   type: Array,
    //   default: ''
    // }
  },
  data() {
    return {
      currentPoint: null,
      centerDialogVisible: false,
      processedText: "",
      info: "",
      list: [],
    };
  },
  methods: {
    handleMessage(event) {
      console.log("收到 iframe postMessage:", event.data);
      console.log("消息来源:", event.origin);
      if (event.data.name) {
        this.showDetail(event.data.name);
      }
    },
    get() {
      // 如果已有缓存数据，直接使用
      if (acupointListCache) {
        this.list = acupointListCache;
        this.parseText();
        return;
      }
      // 如果已有正在进行的请求，等待其完成
      if (acupointListPromise) {
        var self = this;
        acupointListPromise.then(function(data) {
          self.list = data;
          self.parseText();
        });
        return;
      }
      // 首次请求
      var self = this;
      acupointListPromise = new Promise(function(resolve) {
        self.wjtHttp.get(
          self,
          "/api/business/acupointDetails/listAll",
          {},
          false,
          function(res) {
            var data = res.data;
            if (data.code == 200) {
              acupointListCache = data.data;
              self.list = data.data;
              resolve(data.data);
              self.parseText();
            } else {
              self.$message({
                message:
                  data.msg && data.msg.length > 0
                    ? data.msg
                    : "搜索异常，请联系管理员",
                type: "error",
              });
            }
          },
          function(err) {
            console.log(err);
          }
        );
      });
    },
    parseText() {
      let text = this.inputText;
      this.list.forEach((point) => {
        const regex = new RegExp(point.nameAcup, "g");
        text = text.replace(
          regex,
          `<span class="acupoint"  data-point="${point.nameAcup}">${point.nameAcup}</span>`
        );
      });
      this.processedText = text;

      // 只在当前组件内查找穴位元素，避免跨组件重复绑定事件
      this.$nextTick(() => {
        var el = this.$el;
        if (!el) return;
        var points = el.querySelectorAll(".acupoint");
        points.forEach((point) => {
          point.addEventListener("click", this.showAcupointDetail);
        });
      });
    },
    showDetail(name) {
      var that = this;
      this.list.forEach((point) => {
        if (point.nameAcup == name) {
          this.info = point;
        }
      });
      console.log(this.info);
      // this.centerDialogVisible = true;
    },
    showAcupointDetail(e) {
      const pointName = e.target.getAttribute("data-point");
      console.log(pointName);
      var that = this;
      this.list.forEach((point) => {
        if (point.nameAcup == pointName) {
          this.info = point;
        }
      });
      console.log(this.info);
      this.centerDialogVisible = true;
    },
    hideAcupointDetail(e) {
      // this.currentPoint = null;
      // e.target.classList.remove('active');
    },
  },
  mounted() {
    this.get();
    window.addEventListener("message", this.handleMessage);
    // this.parseText();
  },
  beforeDestroy() {
    // 只清理当前组件内的穴位元素事件
    var el = this.$el;
    if (el) {
      var points = el.querySelectorAll(".acupoint");
      points.forEach((point) => {
        point.removeEventListener("click", this.showAcupointDetail);
      });
    }
    window.removeEventListener("message", this.handleMessage);
  },
};
</script>

<style>
.acupoint {
  color: #0da2ff;
  position: relative;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  cursor: pointer;
}

/* 悬停效果 */
.acupointt:hover {
  color: #00c8ff;
  text-shadow: 0 0 8px rgba(0, 200, 255, 0.3);
  background: rgba(0, 200, 255, 0.05);
}
.acupoint-detail-dialog {
  border-radius: 12px !important;
}
.acupoint-detail-dialog .el-dialog__body {
  padding: 20px 24px !important;
}
.WordSegmentPup {
  display: flex;
  height: 60vh;
  gap: 20px;
}
.WordSegmentPupLeft {
  width: 50%;
  padding: 8px 0;
  overflow-y: auto;
}
.WordSegmentPupRight {
  width: 50%;
}
.info-row {
  display: flex;
  align-items: flex-start;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}
.info-row:last-child {
  border-bottom: none;
}
.info-label {
  flex-shrink: 0;
  width: 80px;
  font-size: 14px;
  color: #909399;
  font-weight: 500;
}
.info-value {
  flex: 1;
  font-size: 15px;
  color: #303133;
  line-height: 1.6;
}
.info-value .el-image {
  max-width: 250px;
}
.iframeBox {
  width: 100% !important;
  height: 100% !important;
  border-radius: 10px;
}
</style>